import React from 'react';

const UpcomingEvents = () => {
  const events = [
    {
      city: 'Ahmedabad',
      date: '21st August, 2026',
      time: '6:30 p.m. - 8:30 p.m.',
      venue: 'Crowne Plaza',
      venueLink: '#',
      note: 'Followed by networking dinner'
    }
  ];

  const scrollToInvitation = (e) => {
    e.preventDefault();
    const element = document.getElementById('request-invitation');
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-[100px] bg-white opacity-0 animate-fadeIn-delayed-4">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <h2 className="font-heading font-semibold text-[2rem] relative pb-[15px] mb-8 text-[#333333] text-center">
          Upcoming Dialogues
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-[50px]">
          {events.map((event, index) => (
            <div 
              key={index}
              className="relative overflow-hidden bg-[linear-gradient(135deg,#ffffff_0%,#f8f9fa_100%)] border-2 border-[rgba(0,0,0,0.1)] rounded-xl p-10 shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300 before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-1 before:bg-gradient-to-r before:from-[#6B4DC4] before:to-[#4ECDC4] before:opacity-0 before:transition-all before:duration-300 hover:before:opacity-100 hover:-translate-y-[10px] hover:shadow-[0_10px_30px_rgba(107,77,196,0.2)] hover:border-[#6B4DC4]"
            >
              <h3 className="text-center mb-[30px] text-[1.8rem] text-[#6B4DC4] font-heading font-semibold">
                {event.city}
              </h3>
              <div>
                <p className="mb-5 text-[1.1rem]">
                  <strong>Date:</strong> {event.date}
                </p>
                <p className="mb-5 text-[1.1rem]">
                  <strong>Time:</strong> {event.time}
                </p>
                <p className="mb-5 text-[1.1rem]">
                  <strong>Venue:</strong> <a href={event.venueLink} target="_blank" rel="noopener noreferrer" className="text-[#6B4DC4] hover:underline">{event.venue}</a>
                </p>
                <p className="mb-[15px] text-[1.1rem]">
                  {event.note}
                </p>
                <a 
                  href="#request-invitation" 
                  onClick={scrollToInvitation}
                  className="inline-block bg-gradient-to-br from-[#6B4DC4] to-[#4ECDC4] text-white font-heading font-semibold py-3 px-7 rounded-[25px] uppercase tracking-[1px] text-[0.95rem] transition-all duration-300 shadow-[0_4px_15px_rgba(107,77,196,0.4)] hover:bg-gradient-to-br hover:from-[#4ECDC4] hover:to-[#6B4DC4] hover:-translate-y-[3px] hover:shadow-[0_6px_25px_rgba(78,205,196,0.5)]"
                >
                  Request Invitation
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
